// extracted by mini-css-extract-plugin
export default {"heading":"styles_heading__oDAmA","actions":"styles_actions__NFU6h"};